module.exports = __webpack_public_path__ + "img/3. New listings-th.21f7e38.png";